import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { App } from './app/App';
import { registerServiceWorker } from './pwa/serviceWorker';
import { i18n } from './shared/i18n/i18n';
import './styles/fonts.css';
import './styles/index.css';
import './styles/workspace.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Varza root element was not found.');
}

/*
 * Only a built bundle gets a service worker. Under the dev server the module graph is rewritten on
 * every keystroke, and a worker caching the shell in front of that hides the very changes being
 * made. `vite preview` serves a production build, which is where to exercise the installed
 * application locally.
 */
if (import.meta.env.PROD) registerServiceWorker();

createRoot(rootElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
